import React from "react";
import { SectionHeading } from "./SectionHeading";
import { methodSteps } from "../data/landing";
export function MethodSection() {
  return <section className="bg-canvas" data-id="element-133" data-mp="7s0gxyc3b52a">
      <div className="mx-auto max-w-5xl px-5 py-16 md:py-24" data-id="element-134" data-mp="2tyx3b6ub1pr">
        <SectionHeading eyebrow="A Simple Way to Explore Big Questions" title={<>
              Help Your Child Think Through Faith in <span className="text-royal" data-id="element-136" data-mp="vj5w0ba7htbj">Four Simple Steps.</span>
            </>} subtitle={<p data-id="element-137" data-mp="qkukzx86dcrq">Practical, accessible, and designed for meaningful conversations at home.</p>} data-id="element-135" data-mp="2uig6v887w5d" />

        <ol className="mt-14 grid gap-x-6 gap-y-10 md:grid-cols-2" data-id="element-138" data-mp="ls1h1bkj68gp">
          {methodSteps.map(({
          step,
          icon: Icon,
          title,
          lines
        }) => <li key={step} className="relative rounded-3xl bg-white p-7 pt-10 shadow-[0_10px_30px_-18px_rgba(11,24,56,0.25)] md:p-8 md:pt-11" data-id="element-139" data-mp="hpexdxy0jtul">
              <span className="absolute -top-3.5 left-7 rounded-full bg-gold px-4 py-1.5 font-display text-xs font-extrabold uppercase tracking-wider text-navy" data-id="element-140" data-mp="19i5mloha4iac">
                Step {step}
              </span>
              <span aria-hidden="true" className="absolute right-6 top-4 font-display text-6xl font-extrabold leading-none text-royal-light" data-id="element-141" data-mp="200acwwea2rw9">
                {step}
              </span>
              <Icon className="relative h-8 w-8 text-royal" strokeWidth={2} aria-hidden="true" data-id="element-142" data-mp="1q9pizm9jubjo" />
              <h3 className="relative mt-4 font-display text-2xl font-extrabold text-ink" data-id="element-143" data-mp="1cag0gfxvf5cj">{title}</h3>
              <div className="mt-2 space-y-2 leading-relaxed text-ink-soft" data-id="element-144" data-mp="1hc5gk9zya97h">
                {lines.map(line => <p key={line} data-id="element-145" data-mp="12fxwrasgf9sq">{line}</p>)}
              </div>
            </li>)}
        </ol>

        <p className="mx-auto mt-12 max-w-2xl text-center font-display text-xl font-bold leading-snug text-navy md:text-2xl" data-id="element-146" data-mp="2wruhkkwe5het">
          Faith becomes more than something children hear about. It becomes something they can begin to understand for
          themselves.
        </p>
      </div>
    </section>;
}